import { CustomIconProps } from 'assets/Icons/LibraryIcon';
import React from 'react';

const PlayIcon: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width={width ?? '10'}
      height={height ?? '13'}
      viewBox='0 0 10 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M1.12142 0.498241L8.92782 5.70144C9.01561 5.75986 9.0876 5.83907 9.13739 5.93202C9.18719 6.02498 9.21324 6.12879 9.21324 6.23424C9.21324 6.33969 9.18719 6.44351 9.13739 6.53646C9.0876 6.62941 9.01561 6.70862 8.92782 6.76704L1.11982 11.9702C1.02355 12.0341 0.911793 12.0706 0.796415 12.0761C0.681038 12.0815 0.566337 12.0557 0.464475 12.0012C0.362612 11.9467 0.277386 11.8657 0.217834 11.7668C0.158283 11.6678 0.126626 11.5545 0.126221 11.439V1.02944C0.126435 0.913682 0.158042 0.800149 0.217674 0.700931C0.277307 0.601714 0.362732 0.520528 0.464854 0.466019C0.566976 0.411511 0.68197 0.38572 0.79759 0.391394C0.91321 0.397069 1.02513 0.433995 1.12142 0.498241Z'
        fill={fill ?? 'black'}
      />
    </svg>
  );
};

export default PlayIcon;
